// The English table (ship 3): the same keys, kinds and placeholders as th.js — apps/pet-tag/test/tables.test.js
// holds the two together. Brand names, units and the shapes' svg ids stay as they are.
const S = {
  loading: "Loading…",
  building: "Building…",
  layingOut: "Laying out…",
  makingFile: "Making the file…",
  timedOut: "A build did not finish in 10 seconds and was restarted — try fewer characters or another font",
  loadFailed: "Could not load — try reloading this page",
  triangles: (n) => `${n.toLocaleString('en')} triangles`,
  loading3d: "Loading the 3D view…",
  load3dFailed: "The 3D view could not open — try again",
  fontLoading: (family, got, total) => (total > 0 ? `Loading ${family} ${got} / ${total} MB` : `Loading ${family} ${got} MB`),
  fontLinkNote: (family) => `Could not load ${family} — check the connection · keeping the current font`,
  more: (n) => `${n} more`,
  placeholder: {
    name: "e.g. Big",
    phone: "0812345678",
  },
  emptyEl: "(empty)",
  addTitle: "Add text or an icon",
  resetWarning: "Your custom layout is reset and pieces you added are removed (press ↶ to undo)",
  hint: {
    touch: "Drag anywhere on the tag to move the selected piece — you do not have to press on the letters",
    mouse: "Drag a piece with the mouse, or use the arrow keys (Shift = 1 mm steps)",
  },
  ariaPreview: {
    front: "2D tag preview",
    back: "2D tag preview, back",
  },
  iconSize: "Icon size",
  textSize: "Text size",
  roleLabel: {
    name: "Name",
    phone: "Phone",
    text: "Text",
    icon: "Icon",
  },
  fieldLabel: {
    name: "Pet name",
    phone: "Phone number",
    text: "Text",
    icon: "Icon",
  },
  face: {
    back: " (back)",
  },
  copied: "Link copied — paste it into a chat",
  copyManual: "Automatic copy did not work — press and hold the link above to copy",
  shape: {
    circle: "Round",
    bone: "Bone",
    heart: "Heart",
    paw: "Paw",
    cat: "Cat head",
  },
  template: {
    name: "Name only",
    "name-phone": "Name + phone",
    "name-front-phone-back": "Name front, phone back",
    "icon-name": "Icon + name",
    "icon-name-phone-back": "Icon + name, phone back",
  },
  icon: {
    paw: "Paw",
    heart: "Heart",
    bone: "Bone",
    star: "Star",
    fish: "Fish",
    cat: "Cat",
    dog: "Dog",
    phone: "Phone",
  },
  preset: {
    dog: "Dog",
    cat: "Cat",
    paw: "Paw",
    heart: "Heart",
  },
  engravedNote: "Engraved letters share the tag’s colour — pick “raised” for letters in a second colour",
  singleColour: "One colour — prints on any printer",
  threeMf: (tagName, textName, z, n) => `3MF file: tag = filament 1 (${tagName}), letters = filament 2 (${textName}) · single nozzle: change colour at Z = ${z} mm (layer ${n} @0.2 mm) — the rim around the hole prints in the letters’ colour too`,

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  title: "Pet ID tag",
  lineNote: "Open in a normal browser to download the file — the design you made comes along",
  lineOpen: "Open in browser",
  retryNote: "Could not load — tap to reload",
  faceBtn: { front: "Front", back: "Back" },
  ariaFace: { front: "Front side", back: "Back side" },
  faceNote: "Seen from the back — the text reads normally · the back is always engraved 0.6 mm deep",
  gTag: "Tag style",
  presetsLabel: "Start from a preset",
  ariaPresets: "Presets",
  templatesLabel: "Layout",
  ariaTemplates: "Layout",
  gShape: "Shape",
  shapesLabel: "Tag shape",
  ariaShapes: "Tag shape",
  sizeLabel: "Tag size",
  sizeHint: "For scale: a 10-baht coin is 26 mm",
  sizeRanges: "Cats and small dogs 25–30 · medium dogs 30–38 · large dogs 38 mm and up",
  holeLabel: "Hole for the collar ring",
  holes: { inside: "Inside hole", tab: "Top tab" },
  thickLabel: "Thickness",
  gColour: "Colour",
  modeLabel: "Lettering",
  modes: { raised: "Raised", engraved: "Engraved" },
  colourLabel: { tag: "Tag colour", text: "Text colour" },
  gAdv: "Adjust positions yourself",
  advanced: "Advanced",
  backToSimple: "← Back to simple mode",
  resetTemplate: "Reset to template",
  cancel: "Cancel",
  confirmReset: "OK, reset",
  ariaChips: "Pieces on the tag",
  ariaAdd: "Add a piece",
  addText: "＋ Text",
  ariaSheet: "Adjust the selected piece",
  sheetEmpty: "Tap a piece on the tag, or a chip above, to select the piece to adjust",
  emPre: "Size: ",
  mmPost: " mm",
  nudgePre: "Move 0.25 mm · rotate ",
  nudgePost: "° (tap = 15°, press and hold = 1° at a time)",
  ariaNudge: { left: "Move left", up: "Move up", down: "Move down", right: "Move right" },
  ariaRot: { ccw: "Rotate counter-clockwise", cw: "Rotate clockwise" },
  deletePiece: "Delete this piece",
  aboutH2: "Dog and cat collar tag — name + phone, a 2-colour 3D print",
  aboutP: "Design a collar tag for dogs and cats: your pet's name and your phone number, a choice of shape, icon and two colours (tag + letters) from filaments you can actually buy, then download a 3MF for a multi-colour printer or an STL for single-colour printing. Free in the browser, nothing to install.",
  printLi1: "Print in PLA or PETG at a 0.2 mm layer height",
  printLi2: "Print 2 colours on an AMS/CFS machine — the 3MF already sets the tag as filament 1 and the raised letters as filament 2; pick the real filament colours in your slicer",
  printLi3: "Single-nozzle printer: pause and swap filament at the Z height shown under the text colour",
  footerNote: "Every tag is checked water-tight — the pierced hole and the reinforced ring around it are ready to use",
  ariaDownloads: "Downloads",
  dlstl: "Download STL",
  ariaShareUrl: "Link to this design",
  ariaClose: "Close",
  // a link that cannot open (src/doc.js decodeFragment's codes, worded by src/ui/share-ui.js)
  link: {
    bad: "A link that cannot be used — ask for a new one",
    newer: "This link comes from a newer version",
  },
  // What the worker reports, in words (ruling R9: the worker speaks codes, src/worded.js says them)
  worker: {
    fontLoad: "The font did not load — try again",
    face: {
      front: "front",
      back: "back",
    },
    tooDetailed: (face) => `The text on the ${face} is too detailed — try fewer characters or another font`,
    missingChars: (label, chars) => `${label}: this font has no ${chars}`,
    badChar: (label, point) => `${label}: a character that cannot be used (${point}) — delete it and type again`,
    leadingMark: (label) => `${label} starts with a floating vowel or tone mark — put a consonant before it`,
    empty: "Type your pet's name before downloading",
    tooMany: (max) => `At most ${max} items a side`,
    quoteText: (text) => `"${text}"`,
    quoteIcon: (name) => `The ${name} icon`,
    outside: (what) => `${what} runs over the tag's edge`,
    onHole: (what) => `${what} covers the ring hole`,
    overlap: (what) => `${what} touches or covers another item`,
    tooThin: (what) => `${what} would be too small to print clearly`,
    tooThinBack: (what, factor) => `${what} is too small for the back (the back needs about ${factor} times the size of the front)`,
    tooThinBackFit: (what) => `${what} would be too small to engrave on the back`,
    tooThinTag: (mm) => `The tag is too thin to engrave the back — make it ${mm} mm thick or more`,
    holeWall: "The edge around the ring hole is too thin — try a bigger tag or another hole",
    noFit: {
      front: "The text is too long for a tag this size",
      back: "The text on the back is too long for a tag this size",
    },
    wayOut: (why, way) => `${why} — ${way}`,
    way: {
      plain: "try a bigger tag or shorter text",
      phone: "try a bigger tag, shorter text, or move the phone number to the back",
    },
    phoneToBack: "Move the phone number to the back",
  },
  // the name on this page's share card (R69): the page opens with no name, as it always has — the card shows one
  cardName: "Mochi",
};
export default S;
